jQuery(document).ready(function($){
   

    var swiper = new Swiper(".swiper-collection-bundles", {
        slidesPerView: 1.15, // mobile
        spaceBetween: 16,
        breakpoints: {
            768: { // desktop
                slidesPerView: 3,
                spaceBetween: 40
            }
        }
    }); 



    
    

    $(document).on('click','.collection-filter li',function(){

        var dataAction = $(this).attr('data-action');
        $(this).siblings().removeClass('active');
        $(this).addClass('active');

        localStorage.setItem('selected_collection',dataAction);

        $('body').removeClass('selected-bundle');
        
        switch (dataAction){
            case 'all':
                $('section.section-design-d-collection-bundles').show();
                $('section.design-d-collection-custom-bundle').show();
                $('section.section-design-d-collection-products').show();
                $('.collection-product-item').show();
            break;

            case 'bundles':
                $('body').addClass('selected-bundle');
                $('section.section-design-d-collection-bundles').show();
                $('section.design-d-collection-custom-bundle').show();
                $('section.section-design-d-collection-products').hide();
                $('.collection-product-item').hide();
            break;

            case 'performance':
                $('section.section-design-d-collection-bundles').hide();
                $('section.design-d-collection-custom-bundle').hide();
                $('section.section-design-d-collection-products').show();
                $('.collection-product-item').show();
                $('.collection-product-item[data-handle="onelife-sachets"]').hide();
            break;
            case 'energy':
                $('section.section-design-d-collection-bundles').hide();
                $('section.design-d-collection-custom-bundle').hide();
                $('section.section-design-d-collection-products').show();
                $('.collection-product-item').show();
            break;
            case 'recovery':
                $('section.section-design-d-collection-bundles').hide();
                $('section.design-d-collection-custom-bundle').hide();
                $('section.section-design-d-collection-products').show();
                $('.collection-product-item').show();
                $('.collection-product-item[data-handle="onelife-sachets"]').hide();
            break;
            case 'vegan':
                $('section.section-design-d-collection-bundles').hide();
                $('section.design-d-collection-custom-bundle').hide();
                $('section.section-design-d-collection-products').show();
                $('.collection-product-item').show();
                $('.collection-product-item[data-handle="onelife-sachets"]').hide();
                $('.collection-product-item[data-handle="onefit-sachets"]').hide();
            break;
            case 'longevity':
                $('section.section-design-d-collection-bundles').hide();
                $('section.design-d-collection-custom-bundle').hide();
                $('section.section-design-d-collection-products').show();
                $('.collection-product-item').show();
                $('.collection-product-item[data-handle="onefit-sachets"]').hide();
                $('.collection-product-item[data-handle="onefit-plant-based-sachets"]').hide();
            break;

        }


    });

    let hash = window.location.hash; // Example: "#section1"
    if (hash) {
        let section = hash.substring(1); // removes the "#"
        console.log("URL contains a hash:", hash);
        localStorage.setItem('selected_collection',section);
        $(`.collection-filter li[data-action="${section}"]`).trigger('click');

        // ✅ Remove hash from the URL without reloading the page
        history.replaceState(null, null, ' ');

    } else {
        console.log("No hash in the URL.");
    }

    // if (localStorage.getItem('selected_collection')){
    //     var selectedCollection = localStorage.getItem('selected_collection');
    //     $(`.collection-filter li[data-action="${selectedCollection}"]`).trigger('click');
    // }

});